import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import CustomModal from '../universal/modals/CustomModal';
import { Upload } from '../../workers/ApiWorker';
import { convertSimple } from '../../helpers/Date';
import { useCustomTheme } from '../../contexts/ThemeContext';

interface ChangelogModalProps {
    isOpen: boolean;
    onClose: () => void;
    isMobile: boolean;
    upload: Upload;
}

function sanitizeQuillHtml(data: string) {
    let sanitizedHtml = data.replace(
        /<ol><li data-list="bullet">/g,
        '<ul><li>'
    );
    sanitizedHtml = sanitizedHtml.replace(/<\/li><\/ol>/g, '</li></ul>');
    return sanitizedHtml;
}

const ChangelogModal: React.FC<ChangelogModalProps> = ({
    isOpen,
    onClose,
    isMobile,
    upload,
}) => {
    const { theme } = useCustomTheme();

    const sortedVersions = [...upload.versions].sort(
        (a, b) => b.version - a.version
    );

    return (
        <CustomModal
            isOpen={isOpen}
            onClose={onClose}
            isMobile={isMobile}
            cancelLabel={'Close'}
            width={'60%'}
        >
            <Typography
                variant="h3"
                sx={{ marginBottom: 3 }}
                color={theme.palette.text.secondary}
            >
                CHANGELOG
            </Typography>

            {sortedVersions.map((ver, index) => (
                <Box key={ver.uuid} sx={{ marginBottom: 2 }}>
                    <Typography
                        variant="h5"
                        color={theme.palette.text.secondary}
                        sx={{ marginBottom: 1 }}
                    >
                        VERSION {ver.version} -{' '}
                        {convertSimple(ver.createdAt).toUpperCase()}
                    </Typography>

                    {ver.version === 1 ? (
                        <Typography
                            variant="body1"
                            color={theme.palette.text.secondary}
                        >
                            Initial release
                        </Typography>
                    ) : (
                        <Box
                            sx={{
                                color: theme.palette.text.secondary,
                                '& ul': { paddingLeft: 3, margin: 0 },
                                '& p': { margin: 0 },
                            }}
                            dangerouslySetInnerHTML={{
                                __html: sanitizeQuillHtml(ver.notes ?? ''),
                            }}
                        />
                    )}

                    {index < sortedVersions.length - 1 && (
                        <Divider sx={{ marginTop: 2 }} />
                    )}
                </Box>
            ))}
        </CustomModal>
    );
};

export default ChangelogModal;